import { render, staticRenderFns } from "./AnewMessage.vue?vue&type=template&id=59b9c9c6&scoped=true"
import script from "./AnewMessage.vue?vue&type=script&lang=js"
export * from "./AnewMessage.vue?vue&type=script&lang=js"
import style0 from "./AnewMessage.vue?vue&type=style&index=0&id=59b9c9c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b9c9c6",
  null
  
)

export default component.exports